import React, {useState, useEffect, useRef} from 'react';
import { useCTAL } from './CTAL_Hooks.js';

export default function UserTeamInvitationListItem({member, ndx}) 
{
    const { setUserDisplayRefresh } = useCTAL();
    
    const [error, setError] = useState();
    
    const tooltipRef_accept = useRef(null);
    const tooltipRef_ignore = useRef(null);

    useEffect(() => {
        const tooltip_accept = new window.bootstrap.Tooltip(tooltipRef_accept.current, { container: 'body', trigger: 'hover' });
        const tooltip_ignore = new window.bootstrap.Tooltip(tooltipRef_ignore.current, { container: 'body', trigger: 'hover' });
        return () => { tooltip_accept.dispose(); tooltip_ignore.dispose(); };
    }, []);
    
    var CreatedDT = new Date(member.CreatedAt);
    const formattedDate = CreatedDT.toLocaleString("en-US", {
        day: "numeric",
        month: "short",
        //year: "numeric",
    });

    const send_request = (body) => { 
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-upd`, { method: "POST", body: body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: body })
        .then(() => setUserDisplayRefresh(true))
        .catch(setError);
    }
    
    const accept_team_invitation = () => { 
        var type = "accept_team_invitation";
        var team_id = member.TeamID;
        var user_id = member.UserID;
        var body = JSON.stringify({type, team_id, user_id});

        console.log(`UserTeamInvitationListItem - Accept Team Invitation, body: ${body}`);
        send_request(body);
    }
    
    const reject_team_invitation = () => { 
        var type = "reject_team_invitation";
        var team_id = member.TeamID;
        var user_id = member.UserID;
        var body = JSON.stringify({type, team_id, user_id});

        console.log(`UserTeamInvitationListItem - Reject Team Invitation, body: ${body}`);
        send_request(body);
    }

    return (
        <>
            <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-start" key={ndx}>
                <div class="ms-1 me-auto">
                    <div class="fw-bold">{member.TeamName}</div>
                    <small><i>{formattedDate} by {member.CreatedBy} </i></small>
                </div>
                <div class="ms-auto">
                    <a href="#" ref={tooltipRef_accept} data-bs-toggle="tooltip" data-bs-title="Accept Team Invitation" data-bs-delay="750"><img class="list_item_icon"     src="./images/accept.svg" alt="accept" border="0" onClick={ () => accept_team_invitation() }/></a>                                
                    <a href="#" ref={tooltipRef_ignore} data-bs-toggle="tooltip" data-bs-title="Ignore Team Invitation" data-bs-delay="750"><img class="list_item_icon-end" src="./images/trash.svg"  alt="ignore" border="0" onClick={ () => reject_team_invitation() }/></a>                                
                </div>
            </li>
        </>
    );
}